var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThink(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 645.994,
    height: 594.41,
    viewBox: "0 0 645.994 594.41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.c{fill:#44bba4;}.a{opacity:0.5;}.b{fill:#d0cde1;}.d{fill:#3f3d56;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(287.966 23768.999)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M1050.48,297.813c0,35.17-8.33,64.12-22.78,88.92a177.689,177.689,0,0,1-16.19,23.25c-53.12,64.97-151.88,100.53-241.14,158.13-263.48,170.02-292.02-102.42-280.12-270.3,4.8-67.74,31.18-129.79,73.09-177.3a278.221,278.221,0,0,1,28.45-27.97C639.37,52.023,700.84,27.5,770.37,27.5c119.29,0,221.16,71.95,261.55,173.34a261.85,261.85,0,0,1,18.56,96.97Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M830.054,88.423l-266.71,32.09a278.213,278.213,0,0,1,28.45-27.97Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1027.7,386.733a177.68,177.68,0,0,1-16.19,23.25L783.05,382.5Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1041.24,228.723,654.05,178.5l377.87,22.34a260.467,260.467,0,0,1,9.32,27.88Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M516.519,99.5c0,.69-.02,1.37-.08,2.04a28,28,0,1,1-52.68-15.11,25.736,25.736,0,0,1,2.06-3.31,27.989,27.989,0,0,1,50.6,14.1C516.489,97.975,516.519,98.735,516.519,99.5Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M516.519,99.5c0,.69-.02,1.37-.08,2.04l-41.92-5.04,41.9.72C516.489,97.975,516.519,98.735,516.519,99.5Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M506.519,113.615l-38.78,4.67a28.055,28.055,0,0,1-2.96-3.95Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M495.519,82.615l-31.76,3.82a25.74,25.74,0,0,1,2.06-3.31Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M900.251,603.631c-.323.609-.66,1.2-1.027,1.764a28,28,0,1,1-39.45-38.042,25.754,25.754,0,0,1,3.371-1.958,27.989,27.989,0,0,1,38.086,36.175C900.942,602.265,900.612,602.95,900.251,603.631Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M900.251,603.631c-.323.609-.66,1.2-1.027,1.764l-34.666-24.1,36.674,20.278C900.942,602.265,900.612,602.95,900.251,603.631Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M884.8,611.406,848.36,597.352a28.055,28.055,0,0,1-.763-4.877Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M889.619,578.867l-29.845-11.514a25.742,25.742,0,0,1,3.371-1.958Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M1098.56,120.955c.482.494.942.995,1.367,1.516a28,28,0,1,1-48.264,25.964,25.729,25.729,0,0,1-.836-3.808,27.989,27.989,0,0,1,46.069-25.235C1097.47,119.881,1098.03,120.4,1098.56,120.955Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1098.56,120.955c.482.494.942.995,1.367,1.516l-33.53,25.66,30.5-28.739C1097.47,119.881,1098.03,120.4,1098.56,120.955Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1101.26,138.039l-24.5,30.419a28.057,28.057,0,0,1-4.877-.761Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M1071.74,123.526l-20.07,24.91a25.728,25.728,0,0,1-.836-3.808Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M545.869,350.684l-.464-.061,1.133,4.306a113.168,113.168,0,0,0,4.65,17.677l33.226,126.308a21.408,21.408,0,0,0,17.431,15.71l67.76,10.483a21.408,21.408,0,0,0,22.146-11.052l64.394-120.276a113.014,113.014,0,0,0,5.508-10.288l2.186-4.084-.341-.045a113.847,113.847,0,1,0-217.629-28.677Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M673.763,533.358a23.291,23.291,0,0,1-3.563-.274l-70.829-10.958a23.371,23.371,0,0,1-19.034-17.155L545.606,372.945a119.045,119.045,0,0,1-4.878-18.556l-.878-5.776A120.026,120.026,0,0,1,677.242,214.75l-.307,1.977A118.068,118.068,0,0,0,542,349.64l.675,4.32a118.283,118.283,0,0,0,4.837,18.4l34.754,132.1a21.37,21.37,0,0,0,17.405,15.688L670.5,531.108a21.407,21.407,0,0,0,22.114-11.036l1.764.943a23.421,23.421,0,0,1-20.619,12.342Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 125.314,
    height: 2.587,
    transform: "translate(-99.851 -23299.436) rotate(-69.885)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 2.587,
    height: 125.314,
    transform: "translate(-129.702 -23427.887) rotate(-2.516)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M667.775,593.214l-90.757-14.04a2.587,2.587,0,1,1,.791-5.113l90.757,14.04a2.587,2.587,0,1,1-.791,5.113Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M670.1,573.94,579.345,559.9a2.587,2.587,0,1,1,.791-5.113l90.757,14.04a2.587,2.587,0,1,1-.791,5.113Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M672.429,554.668l-90.757-14.041a2.587,2.587,0,1,1,.791-5.113l90.757,14.04a2.587,2.587,0,0,1-.791,5.113Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M619.575,604.429c18,2.785,34.148-4.99,36.063-17.367l-65.192-10.085C588.532,589.353,601.573,601.644,619.575,604.429Z",
    transform: "translate(-748.485 -23796.502)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M652.2,354.6c-3.872-.6-7.076-3.659-8.833-5.711-.576-.673-1.136-1.37-1.7-2.07-2.046-2.546-3.977-4.951-6.666-6.2-5.937-2.77-12.932,1.1-18.989,5.25l-1.463-2.133c6.659-4.565,14.424-8.782,21.546-5.461,3.235,1.509,5.449,4.265,7.589,6.929.545.679,1.089,1.355,1.647,2.008,1.826,2.133,5.469,5.589,9.372,4.792a12.6,12.6,0,0,0,4.5-2.38,24.082,24.082,0,0,1,3.181-2.007,12.669,12.669,0,0,1,13.907,1.965,25.019,25.019,0,0,1,1.887,2c1.164,1.327,2.262,2.578,3.692,3.034,2.114.676,4.349-.533,6.717-1.809,2.442-1.318,4.966-2.681,7.83-2.345.093.011.187.024.279.038,5.1.788,7.445,6.424,8.774,10.629L703,361.9c-1.806-5.717-4.006-8.56-6.889-8.877-2.051-.241-4.114.872-6.3,2.051-2.738,1.478-5.571,3.007-8.731,2-2.115-.673-3.507-2.259-4.852-3.792a22.789,22.789,0,0,0-1.688-1.793,10.165,10.165,0,0,0-11.012-1.557,21.829,21.829,0,0,0-2.836,1.8,14.7,14.7,0,0,1-5.47,2.8,8.5,8.5,0,0,1-3.023.067Z",
    transform: "translate(-748.485 -23796.502)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThink);
export default __webpack_public_path__ + "static/media/think.7fb146ccf49e8e8fc3a5defac3d84c99.svg";
export { ForwardRef as ReactComponent };